(function($)
{
    $.fn.filenamefield = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.filenamefield.defaults, options);

        return this.each(function() {
             var $this = $(this);
             // build element specific options
             var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
             eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

             var target = $(eOpts['target-selector']);

             target.change(function() {
                 var fileName = target.val();
                 // some browsers may give a full file path so substring just the file name.
                 fileName = fileName.substring(fileName.lastIndexOf('\\') + 1); // Windows paths
                 fileName = fileName.substring(fileName.lastIndexOf('/') + 1); // Unix paths
                 $this.val(fileName);
               });
         });
    };
    //
    // plugin defaults
    //
    $.fn.filenamefield.defaults = {
        'target-selector': ':file'
    };

})(jQuery);